import {
  Briefcase,
  CalendarDays,
  ChartNoAxesColumn,
  FolderOpen,
  House,
  Inbox,
  Settings,
  Timer,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';
import type { Permission } from '@cw/shared';

export type NavLeaf = { label: string; to: string };
export type NavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Fase do ROADMAP em que o módulo ganha funcionalidade real. */
  phase: number;
  permission?: Permission;
  children?: NavLeaf[];
};
export type NavGroup = { label?: string; items: NavItem[] };

/** Estrutura da sidebar (SPEC §6), agrupada pelos pilares do produto (SPEC §2). */
export const NAV: NavGroup[] = [
  {
    items: [
      { label: 'Home', to: '/', icon: House, phase: 1 },
      { label: 'Inbox', to: '/inbox', icon: Inbox, phase: 4 },
    ],
  },
  {
    label: 'Gestão',
    items: [{ label: 'Calendário', to: '/calendar', icon: CalendarDays, phase: 6 }],
  },
  {
    label: 'Negócio',
    items: [
      { label: 'Todos os clientes', to: '/clients', icon: Briefcase, phase: 2 },
      { label: 'Financeiro', to: '/finance', icon: Wallet, phase: 16, permission: 'finance:read' },
      { label: 'Relatórios', to: '/reports', icon: ChartNoAxesColumn, phase: 18, permission: 'reports:read' },
    ],
  },
  {
    label: 'Biblioteca',
    items: [
      { label: 'Assets', to: '/assets', icon: FolderOpen, phase: 7 },
      { label: 'Horas', to: '/time', icon: Timer, phase: 17, permission: 'time:track' },
      { label: 'Equipe', to: '/team', icon: Users, phase: 1, permission: 'members:read' },
    ],
  },
];

export const SETTINGS_ITEM: NavItem = { label: 'Configurações', to: '/settings', icon: Settings, phase: 1 };

export function visibleNav(permissions: readonly Permission[]): NavGroup[] {
  return NAV.map((g) => ({
    ...g,
    items: g.items.filter((i) => !i.permission || permissions.includes(i.permission)),
  })).filter((g) => g.items.length > 0);
}
